export const travel = {
  areas: '旅遊地區'
};

export const vehicle = {
  carNo: '牌照號碼',
  engineNo: '引擎號碼',
  exFactoryDate: '出廠年份',
  carLicenseDate: '發照日期',
  cc: '排氣量',
  maxPassenger: '乘載人數',
  brand: '廠牌',
  carStyle: '車系車型',
  carType: '車種',
};

export const accident = {
  areas: '職業類別'
};

const orderNo = '受理編號';
const period = '投保期間';

export const order = {
  insuName: '投保商品',
  insuCompany: '投保公司',
  insuPeriod: '投保期間',
  premium: '投保金額',
  policyNo: '保單號碼',
  approvedDate: '承保日期',
  orderNo,
  period,
};

export const orderTitles = {
  orderNo,
  policyNo: '保單號碼',
  premium: '保費',
  period
};

export const orderStatus = {
  approved: '已承保',
  pending: '已受理',
  rejected: '拒保'
};

export const orderType = {
  VCN: '疫苗險防疫險',
  TRA: '旅平險',
  AUT: '汽車險',
  MOT: '機車險',
 // ACD: '傷害險',  //20210830 Wen modify
  PET: '寵物險',  //20210530 Wen modify
  
};

export const advisory = {
  insuName: '保單名稱',
  orderNo,
  lastReply: '最近回應時間',
  period
};

export const quesType = {
  CPQ: '保單問題',
  CPC: '保單變更',
  CPS: '保單終止',
  CPO: '理賠相關',
  CPA: '其他'
};

export const user = {
  name: '姓名',
  fullName: '姓名',
  dateOfBirth: '生日',
  mail: 'Email',
  phoneNo: '行動電話',
  identityNo: '身分證字號',
  address: '地址'
};

export const beneficiary = {
  ...user,
  relationship: '關係'
};

export const pet ={
  typeOfPet: '寵物種類',
  dateOfBirthPet: '寵物生日',
  petName: '寵物姓名',
  petGender: '性別',
  petNo: '晶片號碼',
  petBreed: '寵物品種',
  petColor: '毛色',
  petWeight: '體重(KG)',
  petDesc:'特徵說明',
  petPhoto: '寵物照片'
  //petInceptionDate: '投保期間',
};

//export const vaccine = {};  //20210530 Wen Add 